import Invoice from "./Invoice";
import Payment from "./Payment";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import classNames from "classnames";
import Buttons from "./Buttons";
import List from './List';
import isEqual from "lodash-es/isEqual";
import connect from "react-redux/es/connect/connect";
import Button from "../../../form/Button";
import Modal from "../../../layout/Modal";
import RoyaltyReportList from "../../lists/RoyaltyReportList";
import ComponentConfig from "../../../form/ComponentConfig";
import RoyaltyReportForm from "../../forms/RoyaltyReportForm";
import {optionsTemplate} from "../../../../utils/formatters";
import TabContent from "../../../layout/TabContent";
import Tabs from "../../../layout/Tabs";
import Select from "../../../form/Select";
import ComponentLoader from "../../../form/ComponentLoader";
import TargetList from "./Picking/TargetList";
import Discount from "./Discount";
import VatRate from "./VatRate";

class RoyaltiesForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            changeConfirm: false,
            selectedRoyaltyReports: (this.props.props.values.xtradata || {}).reports || [],
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual((this.props.props.values.xtradata || {}).reports, (prevProps.props.values.xtradata || {}).reports)) {
            this.setState({
                selectedRoyaltyReports: (this.props.props.values.xtradata || {}).reports || [],
            });
        }
    }


    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        const sellerProps = props.getProps("seller");
        const customerProps = props.getProps("customer");
        const buttons = <div className="modal-footer with-footer">
            <Buttons {...componentProps} />
        </div>;
        const direction = (props.values.xtradata || {}).direction || "outgoing";
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Tabs
                theme="default"
                className="modal-tabs"
                currentTab={direction}
                onTabChange={(token) => {
                    props.setFieldValue("xtradata.direction", token);
                }}
            >
                <TabContent
                    tabLabel="Kimenő jogdíj"
                    tabName="outgoing"
                >
                    {
                        props.values.id && <form onSubmit={props.handleSubmit}>
                            <div className="row form-row">
                                <div className="col-md-10">
                                    <Select
                                        label={labels.seller || "Jog tulajdonos"}
                                        name="seller"
                                        component="RoyaltyLicensor"
                                        objectValue={true}
                                        labelKey="name"
                                        valueKey="partner_id"
                                        storeType="remote"
                                        optionsTemplate={optionsTemplate("partner")}
                                        {...sellerProps}
                                        disabled={sellerProps.disabled || componentProps.disabled}
                                        value={props.getValue("seller")}
                                        saveChanges={props.setFieldValue}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="control-label">&nbsp;</label>
                                    <Button
                                        color="primary"
                                        disabled={!props.values.seller}
                                        block={true}
                                        onClick={() => {
                                            this.setState({opened: true});
                                        }}
                                    >
                                        Riport kiválasztása
                                    </Button>
                                    {props.values.seller && <Fragment>
                                        <Modal
                                            header="Biztos?"
                                            state={this.state.changeConfirm}
                                            buttons={[
                                                {
                                                    text: "Mégse",
                                                    props: {color: "default", disabled: props.disabled || props.isLoading},
                                                    onClose: true,
                                                    onClick: async () => {
                                                        try {
                                                            this.setState({changeConfirm: false});
                                                        } catch (e) {

                                                        }
                                                    }
                                                },
                                                {
                                                    text: "Igen",
                                                    props: {color: "warning", disabled: props.disabled || props.isLoading || isEqual(this.state.selectedRoyaltyReports, (props.values.xtradata || {}).reports || [])},
                                                    onClick: async () => {
                                                        try {
                                                            await componentProps.setSelectedReports(this.state.selectedRoyaltyReports);
                                                            this.setState({
                                                                selectedRoyaltyReports: this.state.selectedRoyaltyReports,
                                                                opened: false,
                                                                changeConfirm: false
                                                            }, () => {
                                                                this.pool && this.pool.refresh();
                                                            });
                                                        } catch (e) {
                                                            console.error(e);
                                                        }
                                                    }
                                                }
                                            ]}
                                        >
                                            A kiválaszott riportok nem egyeznek az eddig kiválasztottakkal, ha elfogadod a tételek felül lesznek írva!<br/>
                                            Biztos ezt akarod?
                                        </Modal>
                                        <Modal
                                            header="Riport kiválasztása"
                                            state={this.state.opened}
                                            size={"large"}
                                            {...props}
                                            disabled={props.disabled || props.isLoading}
                                            buttons={[
                                                {
                                                    text: "Mégse",
                                                    props: {color: "default", disabled: props.disabled || props.isLoading},
                                                    onClose: true,
                                                    onClick: async () => {
                                                        try {
                                                            this.setState({selectedRoyaltyReports: (props.values.xtradata || {}).reports || [], opened: false, changeConfirm: false});
                                                        } catch (e) {

                                                        }
                                                    }
                                                },
                                                {
                                                    text: "Kiválasztás",
                                                    props: {color: "primary", disabled: props.disabled || props.isLoading || isEqual(this.state.selectedRoyaltyReports, (props.values.xtradata || {}).reports || [])},
                                                    onClick: async () => {
                                                        if (!(isEqual((props.values.xtradata || {}).reports, this.state.selectedRoyaltyReports) ||!(props.values.xtradata || {}).reports)) {
                                                            this.setState({changeConfirm: true});
                                                        } else {
                                                            try {
                                                                await componentProps.setSelectedReports(this.state.selectedRoyaltyReports);
                                                                this.setState({
                                                                    selectedRoyaltyReports: this.state.selectedRoyaltyReports,
                                                                    opened: false,
                                                                    changeConfirm: false
                                                                }, () => {
                                                                    this.pool && this.pool.refresh();
                                                                });
                                                                this.pool && this.pool.refresh();
                                                            } catch (e) {
                                                                console.error(e);
                                                            }
                                                        }
                                                    }
                                                }
                                            ]}
                                        >
                                            <div className="form-group">
                                                <label className="control-label">Riport(ok)</label>
                                                <ComponentConfig componentName="RoyaltyReport">
                                                    <ComponentLoader
                                                        componentName="RoyaltyLicensor"
                                                        filter={{field: "partner_id", value: props.values.seller.partner_id}}
                                                        componentAs={(component) => ({filter: [{field: "licensor", value: component.licensor_id}]})}
                                                    >
                                                        <RoyaltyReportList
                                                           selection={this.state.selectedRoyaltyReports || []}
                                                           selectionMode="multiple"
                                                           actions={false}
                                                           loadForm={(selectedRoyaltyReports) => {
                                                               if (selectedRoyaltyReports) {
                                                                   this.setState({selectedRoyaltyReports: selectedRoyaltyReports.map((item) => item.id).sort((a,b) => a-b)});
                                                               } else {
                                                                   this.setState({selectedRoyaltyReports: []});
                                                               }
                                                           }}
                                                        />
                                                    </ComponentLoader>
                                                </ComponentConfig>
                                            </div>
                                            {
                                                this.state.selectedRoyaltyReports && !!this.state.selectedRoyaltyReports.length &&
                                                <div className="form-group">
                                                    <Tabs
                                                        defaultTab={this.state.selectedRoyaltyReports[0]}
                                                        theme="default"
                                                    >
                                                        {
                                                            this.state.selectedRoyaltyReports.map((reportId, idx) => {
                                                                return <TabContent
                                                                    key={idx}
                                                                    tabLabel={"#" + reportId + " Riport"}
                                                                    tabName={reportId}
                                                                >
                                                                    <ComponentConfig componentName="RoyaltyReport">
                                                                        <ComponentLoader
                                                                            componentName="RoyaltyReport"
                                                                            componentId={reportId}
                                                                            componentAs="values"
                                                                            view="admin"
                                                                        >
                                                                            <RoyaltyReportForm
                                                                                getFieldProps={() => ({disabled: true})}
                                                                            />
                                                                        </ComponentLoader>
                                                                    </ComponentConfig>
                                                                </TabContent>;
                                                            })
                                                        }
                                                    </Tabs>
                                                </div>
                                            }
                                        </Modal>
                                    </Fragment>
                                    }
                                </div>
                            </div>
                            <Invoice {...componentProps} />
                            <div className="row form-row">
                                <Payment {...componentProps} />
                            </div>
                            <Comment {...componentProps} />
                            <div className="row form-row">
                                <div className="col-md-12">
                                    <VatRate {...componentProps} />
                                </div>
                            </div>
                            <TargetList
                                ref={(pool) => this.pool = pool}
                                {...componentProps}
                                control={{visible: false}}
                            />
                        </form>
                    }
                    {buttons}
                </TabContent>
                <TabContent
                    tabLabel="Bejövő jogdíj"
                    tabName="ingoing"
                    disabled={true}
                >
                    {
                        props.values.id && <form onSubmit={props.handleSubmit}>
                            <div className="row form-row">
                                <div className="col-md-10">
                                    <Select
                                        label={labels.customer || "Partner"}
                                        name="customer"
                                        component="partner"
                                        objectValue={true}
                                        labelKey="name"
                                        valueKey="partner_id"
                                        storeType="remote"
                                        optionsTemplate={optionsTemplate("partner")}
                                        {...customerProps}
                                        disabled={customerProps.disabled || componentProps.disabled}
                                        value={props.getValue("customer")}
                                        saveChanges={props.setFieldValue}
                                    />
                                </div>
                            </div>
                        </form>
                    }
                    {buttons}
                </TabContent>
            </Tabs>
        </Fragment>;
    }
}


export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(RoyaltiesForm);